// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"orders-history_wrapper__x1eEk"};